import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { BellRing, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useApi, errMsg } from "@/lib/api";

export const AlertsPanel = () => {
  const api = useApi();
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => api("get", "/api-keys/alerts/recent").then(setD).catch((e) => toast.error(errMsg(e))), [api]);
  useEffect(() => { load(); }, [load]);
  const test = async () => {
    setBusy(true);
    try { const r = await api("post", "/api-keys/alerts/test"); toast.success(`E-mail de test envoyé à ${r.recipients.join(", ")}`); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (!d) return <p className="text-sm text-stone-500">Chargement…</p>;
  return (
    <div className="space-y-6" data-testid="alerts-panel">
      <div className="bg-white border border-stone-200 rounded-lg p-6 flex flex-col sm:flex-row gap-4 sm:items-center text-sm">
        <BellRing className="h-6 w-6 text-[#C2410C] shrink-0" />
        <div>
          <p className="font-medium text-stone-900">Un e-mail est envoyé dès qu'une clé est refusée ou dépasse sa limite.</p>
          <p className="text-stone-600 mt-1" data-testid="alerts-recipients">Destinataires (super-admins) : {d.recipients.join(", ") || "aucun"}. Les refus suivants d'une même clé sont regroupés pendant {d.cooldown_minutes} minutes.</p>
        </div>
        <Button variant="outline" className="sm:ml-auto" disabled={busy} onClick={test} data-testid="alerts-test-button"><Send className="h-4 w-4 mr-1.5" /> Envoyer un test</Button>
      </div>
      <div className="bg-white border border-stone-200 rounded-lg p-6" data-testid="alerts-list">
        <div className="flex items-center"><h3 className="font-heading text-base font-bold text-stone-900">Alertes envoyées</h3><button className="ml-auto text-sm text-[#C2410C] hover:underline" onClick={load} data-testid="alerts-refresh">Actualiser</button></div>
        <div className="mt-3 divide-y divide-stone-100 text-sm">
          {d.alerts.length === 0 && <p className="py-2 text-stone-500">Aucune alerte pour l'instant.</p>}
          {d.alerts.map((a) => (
            <div key={a.id} className="py-2.5 flex flex-wrap gap-x-4 gap-y-1" data-testid={`alert-row-${a.id}`}>
              <span className={`font-mono text-xs font-bold ${a.status === 429 ? "text-amber-700" : "text-red-700"}`}>{a.status}</span>
              <span className="font-medium text-stone-900">{a.key_name}</span>
              <span className="text-stone-700">{a.reason}</span>
              <span className="text-stone-500">{a.ip}</span>
              {a.grouped > 0 && <span className="text-stone-500">+{a.grouped} regroupés</span>}
              <span className={a.errors?.length ? "text-red-700" : "text-green-700"}>{a.recipients?.length ? `Envoyé à ${a.recipients.length}` : "Non envoyé"}{a.errors?.length ? ` · ${a.errors[0]}` : ""}</span>
              <span className="ml-auto text-stone-500">{new Date(a.at).toLocaleString("fr-FR")}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
